// extracted by mini-css-extract-plugin
module.exports = {"item":"EmailList_item__39A9j"};